var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{staticClass:"u-b1",attrs:{"disabled":_vm.isProjectInRequestState || _vm.isProjectLocked,"loading":_vm.isLoading,"data-test":"offer-copy","icon":"copy","type":"default"},on:{"click":_vm.copyOffer}},[_vm._v(" "+_vm._s(_vm.$t('Uredi ponudu'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }